/*
 *
 * EloquaVerify constants
 *
 */

import { defineApiActionTypes } from 'utils/action-helper';
const prefix = 'ui/containers/EloquaVerify';

/*
 * @dev defineApiActionTypes a function that
 * return concat base with START,SUCCESS,FAILURE
 */
export const VERIFY_ELOQUA = defineApiActionTypes(`${prefix}/VERIFY_ELOQUA_START`);
